import React from 'react';
import PatientInfoMembership, { PatientInfoMembershipProps } from './PatientInfoMembership';
import ThemedComponent from '../../theme/ThemedComponent';

export function PatientInfoMembershipWrapper({
  alertService,
  patient,
  membership,
}: PatientInfoMembershipProps): React.JSX.Element {
  return (
    <ThemedComponent>
      <PatientInfoMembership alertService={alertService} patient={patient} membership={membership} />
    </ThemedComponent>
  );
}

export default PatientInfoMembershipWrapper;
